import { render } from "./TestDriveForm.vue?vue&type=template&id=2d41ca06&scoped=true"
import script from "./TestDriveForm.vue?vue&type=script&lang=js"
export * from "./TestDriveForm.vue?vue&type=script&lang=js"

import "./TestDriveForm.vue?vue&type=style&index=0&id=2d41ca06&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d41ca06"]])

export default __exports__